export default {
  homePage: 'Home page',
  tilesAbout: 'About service',
  close: 'Close',
  inn: 'INN (Taxpayer Identification Number)',
  ogrn: 'OGRN (Primary State Registration Number)',
  kpp: 'KPP (Tax Registration Reason Code)',
  cancel: 'Cancel',
  confirm: 'Confirm',
  clearingCode: 'Code of the clearing/trading participant',
  unicode: 'Unicode',
  fullname: 'Full name',
  fullnameEn: 'Full name (in English)',
  orgChangeConfirm: 'Confirm organization change',
  orgChangeConfirmText: 'Are you sure you want to change organization?',
  checkSign: 'Check sign',
  sendAdditionalDocsText: 'Please use the free-form document delivery tool if you need to send more documents',
  sendAdditionalDocsButton: 'Send documents',
  backToRegistrationFailedText: 'Failed to return to registration',
  continueRegistrationText: 'To access the Member\'s Personal Account, please continue with the registration process',
  continueRegistrationButton: 'Continue',
  goToNewInterfaceText: 'You can go to the new home page interface',
  goToNewInterfaceButton: 'New interface',
}